<template>
  <div class="fixed_page"  id="blurry">
    <div class="get-started">
    <div class="get-started-main">
      <div class="fixed_page">
        <div class="main_section_get_started">
          <div class="logo"><img :src="logoMainSrc" alt=""></div>
          <div class="title"><h1>{{ getTranslations.visitor_train_brain }}</h1></div>
          <div v-if="underLogoSrc" class="under_logo">
            <img :src="underLogoSrc" alt="">
          </div>
         <div v-if="freePlayBuutton" >
          <div class="main_buttons_get_started">
            <div class="two_btns">
              <a style="cursor:pointer" @click.prevent="playTrial()" class="ti_btn--main">{{ getTranslations.visitor_free_trial_play }}</a>
            </div>

          </div>
           </div>
        </div>
        <div class="get-started-main_carousel">
          <div class="col-md-12">
            <div class="tab-container__item active" id="daily">
              <carousel/>
            </div>
          </div>
        </div>
        <div class="circle_background">
          <div v-if="!freePlayBuutton" >
          <div class="main_buttons_get_started">
            <div class="two_btns">
              <a @click.prevent="goToRegistration" style="cursor: pointer" class="ti_btn--main">
                {{ getTranslations.visitor_visitor_header_register }}
              </a>
            </div>
            <div class="two_btns">
              <a>
                <router-link :to="'login'" class="ti_btn--second">
                  {{ getTranslations.visitor_visitor_header_login }}
                </router-link>
              </a>
            </div>
          </div>
            <div class="get_started_info_section">
              <div class="col-lg-12">
                <h1>{{ getTranslations.visitor_play_learn_more }} <span class="make_bold"> {{ getTranslations.visitor_win_more }}</span></h1>
                <p> {{ getTranslations.visitor_play_brain_games }}<span class="make_bold"> {{ getTranslations.home_grand_prize_draw }} </span>
                  {{ getTranslations.home_grand_prize_worth }} <span class="make_bold"> {{ getTranslations.visitor_grand_prize_value }}</span></p>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="get_started_info_section for_free_play">

              <div class="col-lg-12">
                <h1>{{ getTranslations.visitor_play_learn_more }} <span class="make_bold"> {{ getTranslations.visitor_win_more }}</span></h1>
                <p> {{ getTranslations.visitor_play_brain_games }}<span class="make_bold"> {{ getTranslations.home_grand_prize_draw }} </span>
                  {{ getTranslations.home_grand_prize_worth }} <span class="make_bold"> {{ getTranslations.visitor_grand_prize_value }}</span></p>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="get_started_list_section" v-if="!hideForExternalRedirectionProjects() && !hideWinners">
              <div class="main_title"><h1> {{ getTranslations.vistitor_winners_winners_history }} </h1></div>

              <div class="filter">

                <a id="#weekly" v-if="hasValue(0)" class="weekly" @click="setFilter($event, 'weekly')">{{ getTranslations.visitor_winners_weekly }}</a>
                <a id="#monthly" v-if="hasValue(1)" class="monthly" @click="setFilter($event,'monthly')">{{ getTranslations.visitor_winners_monthly }}</a>
                <a id="#grand" v-if="hasValue(2)" class="grand" @click="setFilter($event,'grand')">{{ getTranslations.visitor_winners_grand }}</a>
                <a id="#all" v-if="hasValue(3)" class="all current" @click="setFilter($event,'all')">{{ getTranslations.visitor_winners_all }}</a>
              </div>
              <div class="filter_list">
                <visitor-winners v-show="getFilter === 'weekly'" :winners-list="instantWin"/>
                <visitor-winners v-show="getFilter === 'grand'" :winners-list="grandWin"/>
                <visitor-winners v-show="getFilter === 'monthly'" :winners-list="monthlyWin"/>
                <visitor-winners v-show="getFilter === 'all'" :winners-list="allWinners"/>

<!--                <div class="load_more_btn rank" v-if="moreWinnersIButton"> &lt;!&ndash; TODO FIX &ndash;&gt;-->
<!--                  <a href="#" class="load-more btn2 btn2&#45;&#45;std btn2&#45;&#45;small" @click="displayMore(3)">···</a>-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </div>

    </div>
    </div>
      <div class="black-overlay"></div>
    <simplify-registration v-if="showSimpleRegistrationModal"
                                             @close="showSimpleRegistrationModal = false;">
    </simplify-registration>
      <cookies-pop-up v-if="showCookiesPopUp && cookiesPopUpEnabled"
                      @close="showCookiesPopUp = false;">
      </cookies-pop-up>
      <sub-verify-wifi v-if="HE_ERROR_CODE"
                       @close="HE_ERROR_CODE = false;">
      </sub-verify-wifi>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import Vue from 'vue';
import IntegrationMixin from '@/common/mixins/integration';
import RegistrationFlowMixin from '@/common/mixins/flow';
import simplifyRegistration from '@/components/home/modals/SimplifyRegistration';
import cookiesPopUp from '@/components/home/modals/CookiesPopUp';
import subVerifyWifi from '@/components/home/modals/SubscriptionVerifyWifi';
import VisitorWinners from './VisitorWinners';
import Carousel from '../../../../ui-src-brainiac/src/components/home/Carousel';
import SkinMixin from '@/common/mixins/skin';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'index',
  mixins: [IntegrationMixin, RegistrationFlowMixin, SkinMixin],
  components: {
    Carousel,
    VisitorWinners,
    cookiesPopUp,
    simplifyRegistration,
    subVerifyWifi,
  },
  props: ['freePlayBuutton'],
  data() {
    return {
      showSimpleRegistrationModal: false,
      countTestimonials: 0,
      showCookiesPopUp: true,
      showMoreGrand: false,
      showMoreMonthly: false,
      showMoreInstant: false,
      filter: 'all',
      winnersHistoryKeys: ['visitor_winners_weekly', 'visitor_winners_monthly', 'visitor_winners_grand', 'visitor_winners_all'],
    };
  },
  created() {
    if (localStorage.getItem('cookiesEnabled') === 'true') {
      this.showCookiesPopUp = false;
    }
    //  HE flow for TPAY
    if (this.integrationHeader === this.availableIntegrations.TPAY_EGYPT.name) {
      const locale = this.getLocale;
      let lang;
      if (locale === 'EN') {
        lang = 'en';
      } else {
        lang = locale === 'AR' ? 'ar' : 'fr';
      }
      this.$axios.get(`publicapi/loadTpayScript?lang=${lang}`).then((params) => {
        /* eslint-disable */
        let date = params.data.data.date;
        let digest = params.data.data.digest;
        sessionStorage.setItem("redirectUrl", params.data.data.redirectUrl);
        sessionStorage.setItem("can", params.data.data.customerAccountNumber);


        const url = `https://enrichment.tpay.me/idxml.ashx/v2/js?date=${date}&lang=${lang}&digest=${digest}`;

        $.get(url, function (script) {

          console.log(script);
          const scriptToAdd = document.createElement('script'); // Create <script>
          scriptToAdd.type = 'text/javascript';
          scriptToAdd.id = 'tpay_evina_script';
          const code = document.createTextNode(script); // Attach TPay JS script to <script>
          scriptToAdd.appendChild(code);
          document.head.appendChild(scriptToAdd);
          const tag = document.createElement('script');
          tag.type = 'text/javascript';
          tag.id = 'tpay_evina_exe';
          let inlineScript = document.createTextNode("var event = new Event('Call');\n" +
            "const tpay = document.getElementById('tpay_evina_script');\n" +
            "      if (tpay) {\n" +
            "          const enriched = TPay.HeaderEnrichment.enriched();\n" +
            "          console.log(enriched);\n" +
            "          if (enriched) {\n" +
            "             TPay.HeaderEnrichment.hasSubscription(\"sub_product\", \n" +
            "                 async function (result, subId) {\n" +
            "                    if (result) { \n" +
            "                       if (subId) { \n" +
            "                         console.log('subId = ', subId);\n" +
            "                         sessionStorage.setItem(\"subId\", subId);\n" +
            "                         let url = window.location.href; \n" +
            "                         (url.indexOf('?') > -1) ? url += '&' : url += '?' \n" +
            "                         url += 'hasSub=true'; \n" +
            "                         console.log('Redirecting to ', url); \n" +
            "                         window.location.href = url; \n" +
            "                         const btn = document.getElementById('submitBtn');\n" +
            "                         btn.removeAttribute('disabled');\n" +
            "                       } else { \n" +
            "                         console.log('subId is not set. continuing to current page '); \n" +
            "                         const btn = document.getElementById('submitBtn');\n" +
            "                         btn.removeAttribute('disabled');\n" +
            "                       } \n" +
            "                     } else { \n" +
            "                       const btn = document.getElementById('btn');\n" +
            "                       btn.removeAttribute('disabled');\n" +
            "                       console.log('result is: ' + result + ' continuing to current page'); \n" +
            "                     } \n" +
            "                 } \n" +
            "              );\n" +
            "          }\n" +
            "      } else {\n" +
            "          console.log(\"Error loading TPay script\");\n" +
            "      }\n");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode("document.dispatchEvent(event);");
          tag.appendChild(inlineScript);
          document.head.appendChild(tag);
        });
      });
      /* eslint-enable */
    }
  },
  methods: {
    ...mapActions('profile', [
      'storeVisitorWinners',
    ]),
    ...mapMutations('profile', [
      'setMoreWinnersButton',
    ]),
    setFilter(e, category) {
      this.filter = category;
      /* eslint-disable */
      console.log(e.target);
      $('.all').removeClass('current');
      $('.weekly').removeClass('current');
      $('.monthly').removeClass('current');
      $('.grand').removeClass('current');
      $(e.target).addClass('current');
    },
    hasValue(i) {
      return this.getTranslations[this.winnersHistoryKeys[i]] != null;
    },
    goToRegistration() {
      /* eslint-disable */
      if (this.integrationHeader === this.availableIntegrations.TPAY_EGYPT.name) {
        if (!TPay.HeaderEnrichment.enriched()) {
          const msisdn = TPay.HeaderEnrichment.msisdn();
          const operatorCode = TPay.HeaderEnrichment.operatorCode();
          sessionStorage.setItem('msisdn', msisdn);
          sessionStorage.setItem('operatorCode', operatorCode);
          if (sessionStorage.getItem('hasTpaySub') === true || sessionStorage.getItem('hasTpaySub') === 'true') {
            this.$axios.get(`/api/tpayAutologin?msisdn=${msisdn}&opCode=${operatorCode}`).then((response) => {
              console.log(response);
            });
          } else {
            const obj = {
              msisdn: msisdn,
              subscriptionPlanId: '1975',
              productCatalog: 'Play_and_win',
              productSku: 'Play_Win',
              operatorCode: operatorCode,
              customerAccountNumber: sessionStorage.getItem('can'),
              redirectURL: sessionStorage.getItem("redirectUrl"),
            };
            console.log('Confirm return obj = ', obj);

            try {
              TPay.HeaderEnrichment.confirm(obj,
                async function (status, refCode, contract) {
                  console.log('status: ' + status + ' refcode: ' + refCode + ' contract: ' + contract);
                  if (status === true) { // No error or fail case
                    if (contract) { // Redirection Flow
                      return contract;
                    }
                    if (refCode) { // HE Flow
                      const msisdnHE = sessionStorage.setItem('msisdn', TPay.HeaderEnrichment.msisdn());
                      const opCodeHE = sessionStorage.setItem('operatorCode', TPay.HeaderEnrichment.operatorCode());
                      const sessionToken = await TPay.HeaderEnrichment.sessionToken();
                      sessionStorage.setItem('sessionToken', sessionToken);
                      console.log('Got msisdnHE: ', msisdnHE, ' opCodeHE: ', opCodeHE, ' sessionToken: ', sessionToken);
                      this.$axios.get(`/api/addContractRequest?msisdn=${msisdnHE}&operator=${opCodeHE}&lang=${this.getLocale}`).then((res) => {
                        console.log(res);
                      });
                    }
                    // For Wifi flow, proceeds to Register1 w/ Operator Selection Modal
                  } else {
                    console.log('Status returned with: ', status);
                    location.reload(); // If status is 'error' or 'false' then reload
                  }
                }
              );

            } catch (error) {
              console.error(error);
            }
          }
        }
      }
      /* eslint-disable */
      if(this.isRegistrationViaSms) {
        this.$router.push({ name: 'registerViaSMS' });
        return;
      }

      if (!this.hasWebRegister()) {
        this.showSimpleRegistrationModal = true;
      } else {
        this.registrationRedirect();
      }
    },
    playTrial() {
      this.$router.replace('trial/gameFreePlay');
    },
    hideForExternalRedirectionProjects(){
      return this.integrationHeader === this.availableIntegrations.ROSHAN_AFG.name;

    },
    displayMore(i) {
      if (i === 1) {
        if (this.moreWinnersButton) {
          this.showMoreGrand = !this.showMoreGrand;
        }
      }
      if (i === 2) {
        if (this.moreWinnersMButton) {
          this.showMoreMonthly = !this.showMoreMonthly;
        }
      }
      if (i === 3) {
        if (this.moreWinnersIButton) {
          this.showMoreInstant = !this.showMoreInstant;
        }
      }
    },
    normalizeDate(date) {
      moment.locale(localStorage.getItem('locale'));
      return moment(date).format('DD/MM/YYYY');
    },
  },
  computed: {
    getFilter() {
      return this.filter;
    },
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('common', [
      'cookiesPopUpEnabled',
      'availableIntegrations',
      'hideWinners',
    ]),
    ...mapState('profile', [
      'monthlyButton',
      'grandButton',
      'weeklyButton',
      'moreWinnersButton',
      'moreWinnersMButton',
      'moreWinnersIButton',
      'totalWinners',
      'grandWin',
      'monthlyWin',
      'allWinners',
      'instantWin', // weekly winners
    ]),
    ...mapGetters('common', [
      'isRegistrationViaSms',
    ]),
    logoMainSrc() {
      return this.getTranslations.logo_for_get_started_branded_projects
        || this.getTranslations.logo_for_branded_projects
        || this.$_skinImage({ fileName: 'logo_main.svg', skins: [100] });
    },
    underLogoSrc(){
      return (this.duelSkin === 100)
        ? 'static/skins/skin_100/images/lines_1.svg'
        : '';
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/Index.vue